module.exports = __webpack_public_path__ + "static/media/loading-avatar.6aaa3a02.svg";